import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ExtendedPudoTransaction, ExtendedPudoTransactionListResponse, TransactionQueryParams } from '@frontend/transaction/types';

export class TransactionPudoExtendedClient extends APIClient {
    public static readonly endpoint = '/transaction-api/ext/v1';

    public static async fetchPudoExtendedTransactions(queryParams?: ApiQueryParams<TransactionQueryParams>): Promise<ExtendedPudoTransactionListResponse> {
        return await this.apiPaginated<ExtendedPudoTransactionListResponse, TransactionQueryParams>(`${this.endpoint}/pudo-transactions`, queryParams);
    }

    public static async fetchPudoExtendedTransaction(accountId: string, transactionId: string): Promise<ExtendedPudoTransaction> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/pudo-transactions/${transactionId}`);
        return await this.handleResponse<ExtendedPudoTransaction>(response);
    }
}
